export enum MEDICARE_STATUSES {
  ELIGIBLE = 'eligible',
  ENROLLED = 'enrolled',
  NOT_ELIGIBLE = 'not_eligible'
}
